import React, { createContext, useContext, useEffect, useReducer } from 'react';
import atatus from 'atatus';

import { getStatements } from '../../services/AccountService';
import useAccounts from '../useAccounts';

import statementsReducer from './statementsReducer';
const Context = createContext();

export const StatementsProvider = ({ children }) => {
    const { accounts } = useAccounts();
    const [state, dispatch] = useReducer(statementsReducer, {});

    useEffect(() => {
        if (!accounts) {
            return;
        }

        const payload = {};
        for (const { accountNumber, hasStatements } of accounts) {
            if (hasStatements) {
                payload[accountNumber] = {
                    error: null,
                    isFetchingStatements: false,
                    listOfStatements: null,
                };
            }
        }
        dispatch({ payload, type: 'ACCOUNTS_UPDATED' });
    }, [accounts]);

    /**
     * @fetchStatements will @GET all statements for the provided @accountNumber
     * Before making the request, we need to verify
     * If we already have the list of statements for @accountNumber
     * Or if we are currently fetching the list of statement.
     * Or if we have an error from the previous fetch.
     * If any of the 3 checks are true, we do an early return and the @GET request is not made.
     **/
    const fetchStatements = async (accountNumber) => {
        const account = state[accountNumber];
        if (account.isFetchingStatements) {
            return;
        }
        atatus.startTransaction('GetStatements');
        try {
            dispatch({
                payload: { accountNumber },
                type: 'FETCH_INIT',
            });

            const results = await getStatements(accountNumber);

            dispatch({
                payload: { accountNumber, listOfStatements: results },
                type: 'FETCH_SUCCESS',
            });
            atatus.endTransaction('GetStatements');
        } catch (error) {
            dispatch({ payload: { accountNumber, error }, type: 'FETCH_FAILURE' });
            atatus.failTransaction('GetStatements');
        }
    };

    return <Context.Provider value={{ accountStatements: state, fetchStatements }}>{children}</Context.Provider>;
};

const useStatements = () => useContext(Context);

export default useStatements;
